import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {}

interface Variables {
    applicationStageId: string,
    newStatus: 'APPROVED' | 'REJECTED'
}

export const CHANGE_APPLICATION_STAGE_STATUS: TypedDocumentNode<Result, Variables> = gql`
    mutation ChangeApplicationStageStatus($applicationStageId: Int!, $newStatus: EnumStageStatus!){
        changeApplicationStageStatus(applicationStageId: $applicationStageId, newStatus: $newStatus)
    }       
`
